import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';

// component
import Connect from './Connect';
import { localGetStorage } from '@/lib/storage';
// api
// lib
import { appUpdate } from '@/lib/appUpdate';
/// import { useWeb3 } from '@/hooks/use-web3';
// import PopupList from './PopupList';

import { useWeb3AuthConnect, useWeb3AuthUser } from '@web3auth/modal/react';
import { useWeb3 } from '@/contexts/web3Provider';
import { toast } from 'react-toastify';
import { useOutLinkInfo, useOutLinkInfoActions } from '@/store/zustand/store';

export default function WalletMain() {
  const navigate = useNavigate();
  const { isConnected } = useWeb3AuthConnect();
  const { userInfo } = useWeb3AuthUser();
  const { isInitialized } = useWeb3();
  const outLinkInfo = useOutLinkInfo();
  const { setOutLinkInfo } = useOutLinkInfoActions();
  const outLinkProcessed = useRef(false);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      appUpdate(); // 추후 서버에서 버전 관리리
    }
    return () => {};
  }, []);

  // 결제 요청 링크에서 왔을 때 해당 경로로 이동
  useEffect(() => {
    if (outLinkProcessed.current) return;
    if (!isConnected || !isInitialized) return;
    if (!outLinkInfo.path || !outLinkInfo.toAddr) return;

    outLinkProcessed.current = true;
    const targetPath = `/${outLinkInfo.path}`;
    console.log('WalletMain - outLinkInfo detected, navigating to:', targetPath);

    // replace: true로 히스토리 교체 (뒤로가기 시 WalletMain이 아닌 이전 페이지로)
    navigate(targetPath, { replace: true });
  }, [isConnected, isInitialized, outLinkInfo, navigate]);

  // web3auth 연결 여부 체크
  useEffect(() => {
    // web3Provider 초기화 완료 전이면 체크하지 않음
    if (!isInitialized) {
      return;
    }

    // 초기화 완료 후 연결 안 되어 있으면 로그인 페이지로 이동
    if (!isConnected && !userInfo) {
      toast.error('세션이 만료되었습니다.');
      navigate('/signInSns');
    }
  }, [userInfo, isConnected, isInitialized, navigate]);

  // pinComponent 핀번호 유무 체크
  useEffect(() => {
    (async () => {
      if (!isConnected) {
        return;
      }
      // const address = await web3authCall?.getAddress();
      // console.log(address);
      // const { idToken, oAuthIdToken, verifier, verifierId } = await web3authCall!.getUserInfo();

      // addChainList();
      checkSnsPinNum();
    })();

    return () => {};
  }, [isConnected]);

  // const addChainList = () => {
  //   // 최소 0번은 이미 세팅되어 있어서 제외
  //   for (let i = 1; i < connector!.chains.length; i++) {
  //     connector?.options?.web3AuthInstance.addChain(web3AuthChainConfig(connector.chains[i]));
  //     // console.log(chains[i]);
  //     // .addChain(web3AuthChainConfig(chains[i]));
  //   }
  // };
  const checkSnsPinNum = () => {
    const re = localGetStorage('snsAddress') || undefined;
    if (!re?.pinNum) {
      navigate('/pinComponent', {
        state: {
          pinType: 'setting',
          title: 'sns 핀번호 세팅',
          returnUrl: '/wallet',
          // idToken: aIdToken,
        },
      });
    }
  };

  return (
    <>
      {/* {connectors.map((connector) => {
        return (
          <>
            <button className="card" key={connector.id} onClick={() => connect({ connector })}>
              {connector.name}
            </button>
            <button className="card" onClick={disconnect as any}>
              Disconnect
            </button>
          </>
        );
      })} */}
      {/* {list &&
        list.map((item: resBoardPopListProps) => (
          <Fragment key={item.board_id}>
            <BoardPopup board_id={item.board_id} board_type={item.board_type} title={item.title} post={item.post} />
          </Fragment>
        ))} */}

      <Connect />
      {/* <Connect />{isConnected ? <Connect /> : <DisConnect />} */}
      {/* <PopupList /> */}
    </>
  );
}
